;(() => {
  class PdpPopupPortal extends XThemeBaseElement {
    mount() {
      const popup = this.querySelector('.quick-links-popup')
      if (document.body && popup && popup.parentElement !== document.body) {
        document.body.appendChild(popup)
      }
    }
  }

  if (!window.customElements.get('x-pdp-popup-portal')) {
    window.customElements.define('x-pdp-popup-portal', PdpPopupPortal)
  }
})()
